import axios from 'axios';

const GET_SITE_INFO = '/.netlify/functions/getSiteInfo';

const GetSiteInfo = async () => {

  const fetchData = async (): Promise<any> => {
    try {
      const infoResponse = await axios.post(GET_SITE_INFO, {}, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if( infoResponse.status == 200) {
        return infoResponse.data[0].data;
      }
    } catch (err) {
      console.log(err);
    }
  };

  return await fetchData();
};

export default GetSiteInfo;